import { render, staticRenderFns } from "./LandingApp.vue?vue&type=template&id=07ce4e3d"
import script from "./LandingApp.vue?vue&type=script&lang=js"
export * from "./LandingApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports